import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { ALERT_TYPE } from 'src/app/constants';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { AdminRemark } from 'src/model/customerAdminRemark';

@Component({
    selector: 'app-add-admin-remark',
    templateUrl: './add-admin-remark.component.html',
    styleUrls: ['./add-admin-remark.component.scss'],
    standalone: false
})
export class AddAdminRemarkComponent {
  private activeModal = inject(NgbActiveModal);
  private sharedService = inject(SharedService);
  private restapi = inject(RestApiService);
  private constructApi = inject(ConstructAPI);

  adminRemark: string;
  disabledSubmit = false;

  needAttention = false;
  @Input() viewCustomerId: number;
  @Output() passEntry = new EventEmitter<any>();

  submit() {
    (this.adminRemark == undefined || this.adminRemark == "")
      ? this.sharedService.openAlert('Please fill in all the fields correctly!', ALERT_TYPE.DANGER)
      : this.addRemark();
  }

  addRemark() {
    const data = {
      "remark": this.adminRemark,
      "date": new Date().toISOString(),
      "needAttention": this.needAttention
    };
    const xhr = this.restapi.postRequest(this.constructApi.getAddAdminRemark(this.viewCustomerId), data);
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4 && xhr.status == 200) {
        const json = JSON.parse(xhr.responseText);

        const remark = new AdminRemark(json.id, json.author, json.customerId, json.date, json.remark, json.needAttention)
        this.passEntry.emit(remark)
        this.reset();
        this.sharedService.openAlert("Successfully added remark!", ALERT_TYPE.SUCCESS);
      }
    }
  }

  reset() {
    this.adminRemark = "";
    this.activeModal.close();
  }
}
